export default "__VITE_ASSET__0e06b2a6__"